import { render, staticRenderFns } from "./PlayProjectDialog.vue?vue&type=template&id=3d88cd32&scoped=true&"
import script from "./PlayProjectDialog.vue?vue&type=script&lang=js&"
export * from "./PlayProjectDialog.vue?vue&type=script&lang=js&"
import style0 from "./PlayProjectDialog.vue?vue&type=style&index=0&id=3d88cd32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d88cd32",
  null
  
)

export default component.exports